import React from "react";
import {
  Dialog,
  DialogContent,
  IconButton,
  Typography,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const CommonPopup = ({
  open,
  onClose,
  type = "success", // "success" | "error"
  message = "",
  title,
}) => {
  const isSuccess = type === "success";

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        style: {
          borderRadius: "16px",
          padding: "10px",
          minWidth: "300px",
          maxWidth: "350px",
          textAlign: "center",
          borderTop: isSuccess
            ? "5px solid #4CAF50"
            : "5px solid #ff3c3c",
        },
      }}
      sx={{ zIndex: 2001 }}
    >
      {/* Close icon */}
      <IconButton
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent>
        {/* Title */}
        <Typography
          variant="h6"
          sx={{
            color: isSuccess ? "#4CAF50" : "#ff3c3c",
            fontWeight: "bold",
            mb: 1,
            fontFamily: "Montserrat",
          }}
        >
          {title || (isSuccess ? "Success!" : "Error")}
        </Typography>

        {/* Message */}
        <Typography
          variant="body1"
          sx={{ color: "#555", fontFamily: "Montserrat" }}
        >
          {message}
        </Typography>

        {/* OK Button */}
        <Button
          onClick={onClose}
          sx={{
            mt: 2,
            borderRadius: "50px",
            background:
              "linear-gradient(rgba(255,255,255,0.3), rgba(255,255,255,0.22)), linear-gradient(90deg, #f78c25, #ff3c3c)",
            color: "#fff",
            fontWeight: 600,
            textTransform: "none",
            px: 4,
          }}
        >
          OK
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default CommonPopup;
